import { InputRegistry } from "kanopi-components/InputRegistry"; // TODO: Maybe rename this to ComponentRegsitry

import { ButtonRhetorical } from "./ButtonRhetorical";
import { MarkdownRhetorical } from "./MarkdownRhetorical";
import { CalloutRhetorical } from "./CalloutRhetorical";

export const rhetoricalRegistry = new InputRegistry({
  button: ButtonRhetorical,
  markdown: MarkdownRhetorical,
  callout: CalloutRhetorical,
});
